import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stepper-wrapper d-flex align-items-center" }
const _hoisted_2 = { class: "stepper-icon w-40px h-40px" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }, null, -1)
const _hoisted_4 = { class: "stepper-number" }
const _hoisted_5 = { class: "stepper-label" }
const _hoisted_6 = { class: "stepper-title" }
const _hoisted_7 = { class: "stepper-desc" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-line h-40px" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stepper-item me-5", _ctx.colClass]),
    "data-kt-stepper-element": "nav"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.stepperNo), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.stepperTitle), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("small", null, _toDisplayString(_ctx.stepperDescription), 1)
        ])
      ])
    ]),
    _hoisted_8
  ], 2))
}